import { Button } from '@aloft/toolkit-sui';

import { useWatch } from 'react-hook-form';

import { useZodFormContext } from '../../../../hooks/useZodForm.ts';
import { countActiveFilters } from '../../../FilterDrawer/countActiveFilters.ts';
import { RecommendCompsFormSchema } from '../../types.ts';

export const FilterDrawerButton = ({ onFilterDrawerOpen }: { onFilterDrawerOpen: () => void }) => {
  const { control } = useZodFormContext<RecommendCompsFormSchema>();
  const filters = useWatch({
    name: 'search.filters',
    control,
  });

  return (
    <Button
      icon="filter"
      size="md"
      variant="secondary"
      text={`Filters (${countActiveFilters(filters)})`}
      onClick={onFilterDrawerOpen}
      disabled={false}
      __dangerDoNotUseSx={{ padding: '0 14px' }}
    />
  );
};
